export default __webpack_public_path__ + "static/media/banner-4.b751b28a.jpg";